import http from 'utils/request'
import { Judgement, ResponseModel, ResponsePaginationDataModel } from 'api/base-model'
import {
  MeetingModel,
  DraftParamsModel,
  DraftQueryModel,
  DraftModel,
  MeetingQueryModel,
  MeetingStepParams,
  MeetingThemeInfoModel,
  MeetingThemeModel,
  MeetingGoodModel,
  MeetingInvitationQueryModel,
  MeetingInvitationModel
} from 'api/meeting-model'

export function getMeetingList({
  meeting_progress = undefined,
  ...rest
}: MeetingQueryModel) {
  return http.Post<ResponseModel<ResponsePaginationDataModel<MeetingModel>>>(
    '/info/meeting/list',
    { ...rest, meeting_progress }
  )
}

export function getMeetingInvitationList({ meeting_id, ...rest }: MeetingInvitationQueryModel) {
  return http.Post<ResponseModel<ResponsePaginationDataModel<MeetingInvitationModel>>>(
    `/invitations/${meeting_id}/getInvitationList`,
    { ...rest, meeting_id }
  )
}


export function editMeeting(data: MeetingModel) {
  return http.Put<ResponseModel>(`/info/meeting/edit/${data.id}`, data)
}

export function addMeeting(data: MeetingModel) {
  return http.Post<ResponseModel>('/info/meeting/add', data)
}

export function exportMeeting() {
  return http.Get('/info/meeting/export')
}

export function deleteMeetingRequest(projectId: string) {
  return http.Delete<ResponseModel>(`/info/meeting/requestDelete/${projectId}`)
}

export function deleteMeeting(projectId: string) {
  return http.Delete<ResponseModel>(`/info/meeting/delete/${projectId}`)
}

export function sendInvitation(data: any) {
  return http.Post<ResponseModel>(
    `/invitations/${data.ivitation_dto?.meeting_id}/sendInvitation`,
    data
  )
}

export function saveDraft({ meeting_id, ...rest }: DraftParamsModel) {
  return http.Post<ResponseModel>(`/invitations/draftEdit/${meeting_id}`, rest)
}

export function getDraftList({ meeting_id, ...rest }: DraftQueryModel) {
  return http.Post<ResponseModel<DraftModel>>(`/invitations/draft/${meeting_id}`, {
    ...rest
  })
}

export function editMeetingConfigBaseInfo({
  id,
  meeting_id,
  ...rest
}: MeetingModel) {
  return http.Put<ResponseModel>(`/info/meeting/${meeting_id}/configBaseInfo/${id}`, {
    ...rest
  })
}

export function getMeetingThemeInfo(meeting_id: string) {
  return http.Post<ResponseModel<MeetingThemeInfoModel>>(
    `/info/meeting/${meeting_id}/themeInfo`
  )
}

export function recordMeetingStep({ meeting_id, ...rest }: MeetingStepParams) {
  return http.Put<ResponseModel>(`/info/meeting/recordStep/${meeting_id}`, { ...rest })
}

export function editMeetingThemeInfo(
  { meeting_id, id }: MeetingThemeInfoModel,
  data: MeetingThemeModel
) {
  return http.Put<ResponseModel>(`/info/meeting/${meeting_id}/configTheme/${id}`, data)
}

export function checkMeetingStart(id: string) {
  return http.Post<Judgement>(`/info/meeting/checkMeetingStart/${id}`)
}

export function configGoods(meeting_id: string, goodsIds: string[]) {
  return http.Put<ResponseModel>(`/info/meeting/${meeting_id}/configGoods`, { goodsIds })
}

export function getGoodsId(meeting_id: string) {
  return http.Post<ResponseModel<ResponsePaginationDataModel<MeetingGoodModel>>>(
    `/info/meeting/${meeting_id}/goodsId`
  )
}

//2848x1600 3136x1344 b64_json url
export function generateImage(id:string, meeting_id:string, prompt: string,width: number,height: number,responseFormat:'b64_json'|'url'='b64_json',model:string='doubao-seedream-5-0-260128') {
  return http.Post<ResponseModel>(`/info/meeting/${meeting_id}/generateImage/${id}`, {
    prompt,
    width,
    height,
    model,
    responseFormat
  },{ timeout: 0})
}